import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-white",
        outline: "text-foreground",
        /*
          On the same tokens as `shared/status-badge.tsx`, not raw Tailwind
          palette colours. These two hard-coded emerald/amber with their own
          `dark:` branches, which meant the app carried TWO status-colour
          languages: a workspace brand override restyled every StatusPill (34
          consumers) and left Badge untouched, so theming looked half-broken.
          The tokens also supply dark mode, so the manual branches go.
        */
        success: "border-transparent bg-success-bg text-success-foreground",
        warning: "border-transparent bg-warning-bg text-warning-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Badge({
  className,
  variant,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof badgeVariants>) {
  return <div data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
